module.exports = __webpack_public_path__ + "img/loader.a517d320.gif";